// @ts-check

import angular from 'angular';
import * as uuid from 'uuid';

import RelivConferenceTicket from './reliv-conference-ticket';
import RelivConferenceFeature from './reliv-conference-feature';
import RelivConferenceOrderItem from './reliv-conference-order-item';

/**
 * relivConference.relivConferenceModelFactory
 */
angular.module('relivConference').service('relivConferenceModelFactory', [
  function () {
    return {
      newTicket(uid) {
        if (typeof uid === 'undefined') {
          uid = uuid.v4();
        }
        return new RelivConferenceTicket(uid);
      },
      newFeature(uid) {
        if (typeof uid === 'undefined') {
          uid = uuid.v4();
        }
        return new RelivConferenceFeature(uid);
      },
      newOrderItem(skuNumber, type) {
        return new RelivConferenceOrderItem(skuNumber, type);
      },
    };
  },
]);
